module.exports = __webpack_public_path__ + "img/AWS-Developer-Associate-2020.f5b1df97.png";